import Vue from 'vue'

import steps from '../../appdata/steps.js'
import { mapFields } from 'vuex-map-fields'
var StepFunctions = {
  data() {
    return {
      quiz: steps,
      answer: null,
      autoMove: true,
      moved: false,
    }
  },
  watch: {
    // whenever question changes, this function will run
    answer: function (newAnswer, oldAnswer) {
      if (typeof newAnswer != 'undefined') {
        let answers = this.answers
        
        const answer = this.getAnswerObject(newAnswer);
        
        var removeIndex = answers.map(item => item.id).indexOf(this.stepKey)
        
        // if not answered then push answer
        ~removeIndex && answers.splice(removeIndex, 1)
        answers.push(answer)
        this.answers = answers
        
        if (removeIndex == -1) {
        }
        if ((this.autoMove === true) && (this.moved === false)) {
          this.moved = true;
          setTimeout(() => {
            this.$eventBus.$emit('quiz-nav', 'next')
            this.moved = false;
          }, 3000)
        }
      }
    }
  },
  computed: {
    // saved answers
    ...mapFields(['answers']),
    // current step
    step: {
      get() {
        return this.quiz.steps[this.stepKey]
      }
    },
    stepKey: {
      get() {
        // saved in route meta
        return this.$route.meta.stepKey
      }
    }
  },
  methods: {
    getAnswerObject(newAnswer) {
      let points = this.answerPoints(newAnswer)
      const answer = {
        id: this.stepKey,
        value: newAnswer,
        points: points
      }
      return answer;
    },
    // returns answer by id
    findAnswer(id) {
      return this.step.responses.find(question => question.value == id)
    },
    // return answer points
    answerPoints(id) {
      let answerObject = this.findAnswer(id)

      if (Object.keys(answerObject).includes('points')) {
        return answerObject.points
      } else {
        return 0
      }
    },
  }
  
}
  
export default StepFunctions;


// WEBPACK FOOTER //
// ./src/components/mixins/StepFunctions.js